module.exports = __webpack_public_path__ + "img/News1.a320b35e.png";